import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["xlink:href"]

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'IconBase',
  props: {
  name: {
    type: String,
    default: 'like'
  },
  width: {
    type: Number,
    default: 50
  },
  height: {
    type: Number,
    default: 50
  },
  viewBox: {
    type: String,
    default: '0 0 50 50'
  },
  prefix: {
    type: String,
    default: 'icon'
  }
},
  setup(__props) {

const props = __props
const href = computed(() => {
  /* eslint-disable */
  let icon = require(`@/assets/icons/${props.name}.svg`)
  if (Object.prototype.hasOwnProperty.call(icon, 'default')) {
    icon = icon.default
  }

  return window.location.origin+icon.url
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.width,
    height: __props.height,
    viewBox: __props.viewBox,
    class: "icon-sprite"
  }, [
    _createElementVNode("use", {
      "xlink:href": href.value,
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})